export default {
  'menu.referrals': 'Referrals',
  'pages.referrals.action.detail': 'Detail',
  'pages.referrals.action.refresh': 'Refresh',
  'pages.referrals.column.action': 'Action',
  'pages.referrals.column.amBitId': 'AmBit ID',
  'pages.referrals.column.avatarUrl': 'Avatar',
  'pages.referrals.column.createdAt': 'Created at',
  'pages.referrals.column.id': 'Relationship ID',
  'pages.referrals.column.nickname': 'Nickname',
  'pages.referrals.column.referred': 'Referred user',
  'pages.referrals.column.referrer': 'Referrer',
  'pages.referrals.column.userId': 'User ID',
  'pages.referrals.detail.referred': 'Referred user',
  'pages.referrals.detail.referrer': 'Referrer',
  'pages.referrals.detail.relationship': 'Referral relationship',
  'pages.referrals.detail.title': 'Referral detail: {id}',
  'pages.referrals.empty.detail': 'No data',
  'pages.referrals.search.referredUserId': 'Referred user ID',
  'pages.referrals.search.referrerUserId': 'Referrer user ID',
  'pages.referrals.title': 'Referral Management',
};
